export default __webpack_public_path__ + "static/media/m.d4771d5a.jpg";